<mat-slide-toggle
  [checked]="checked"
  [disabled]="disabled"
  class="ed-switch {{ size }}"
  (change)="onToggle($event.checked)">
  {{ label }}
</mat-slide-toggle>